import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ArrowLeftRight, Check, Search, X } from "lucide-react";
import React from "react";

const PrescriptionsList: React.FC = () => {
    const prescriptions = [
        {
            patientName: "John Smith",
            rxNumber: "RX-001-857",
            medication: "Amoxicillin 500mg, ...",
            qty: 30,
            status: "Pending",
            pharmacist: "Jane Doe"
        },
        {
            patientName: "Sarah Johnson",
            rxNumber: "RX-001-235",
            medication: "Lisinopril 10mg, Betazol, +1",
            qty: 60,
            status: "Approved",
            pharmacist: "Mike Wilson"
        },
        {
            patientName: "Robert Brown",
            rxNumber: "RX-001-987",
            medication: "Metformin 1000mg, Lisinopril ...., +3",
            qty: 90,
            status: "Pending",
            pharmacist: "Jane Doe"
        },
        {
            patientName: "Emily Davis",
            rxNumber: "RX-001-456",
            medication: "Ibuprofen 200mg",
            qty: 20,
            status: "Hold",
            pharmacist: "Sarah Lee"
        },
        {
            patientName: "Michael Miller",
            rxNumber: "RX-001-654",
            medication: "Atorvastatin 20mg",
            qty: 60,
            status: "Approved",
            pharmacist: "Mike Wilson"
        },
        {
            patientName: "John Smith",
            rxNumber: "RX-001-321",
            medication: "Amoxicillin 500mg",
            qty: 30,
            status: "Pending",
            pharmacist: "Jane Doe"
        },
        {
            patientName: "Sarah Johnson",
            rxNumber: "RX-001-789",
            medication: "Lisinopril 10mg",
            qty: 60,
            status: "Approved",
            pharmacist: "Mike Wilson"
        },
        {
            patientName: "Emily Davis",
            rxNumber: "RX-001-123",
            medication: "Ibuprofen 200mg",
            qty: 20,
            status: "Hold",
            pharmacist: "Sarah Lee"
        }
    ];

    const getStatusBadge = (status: string) => {
        switch (status) {
            case "Pending":
                return <Badge variant="secondary" className="bg-orange-100 text-orange-700 hover:bg-orange-100">Pending</Badge>;
            case "Approved":
                return <Badge variant="secondary" className="bg-green-100 text-green-700 hover:bg-green-100">Approved</Badge>;
            case "Hold":
                return <Badge variant="secondary" className="bg-yellow-100 text-yellow-700 hover:bg-yellow-100">Hold</Badge>;
            default:
                return <Badge variant="secondary">{status}</Badge>;
        }
    };

    return (
        <div className="w-full border border-gray-200 rounded-lg p-4 flex flex-col items-start justify-start">
            <div className="flex flex-row items-center justify-between w-full mb-4">
                <div className="flex flex-col items-start justify-center">
                    <div className="flex flex-row items-center justify-start gap-x-2">
                        <span className="text-lg">Prescription List</span>
                        <Badge className="font-medium" variant="secondary">8 active</Badge>
                    </div>
                    <span className="text-sm font-normal text-gray-500">Pending and approved prescriptions, click to view more details</span>
                </div>
                <div className="flex flex-row items-center justify-end gap-x-2">
                    <Input placeholder="Search patients..." className="w-[300px]" prefixIcon={<Search className="w-5 h-5 text-gray-400 mr-2"/>} />
                    <Button variant="outline"><ArrowLeftRight className="mr-2 h-4 w-4" />Sort</Button>
                </div>
            </div>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Patient Name</TableHead>
                        <TableHead>Medication</TableHead>
                        <TableHead>Qty</TableHead>
                        <TableHead>Status</TableHead>
                        <TableHead>Pharmacist</TableHead>
                        <TableHead className="flex flex-row items-center justify-end">Actions</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {prescriptions.map((prescription, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <div className="flex flex-col">
                                    <span className="font-medium">{prescription.patientName}</span>
                                    <span className="text-sm text-gray-500">{prescription.rxNumber}</span>
                                </div>
                            </TableCell>
                            <TableCell>{prescription.medication}</TableCell>
                            <TableCell>{prescription.qty}</TableCell>
                            <TableCell>{getStatusBadge(prescription.status)}</TableCell>
                            <TableCell>{prescription.pharmacist}</TableCell>
                            <TableCell>
                                <div className="flex flex-row items-center justify-end gap-x-2">
                                    {prescription.status === "Pending" || prescription.status === "Hold" ? (
                                        <>
                                            <Button size="sm" className="bg-blue-600 hover:bg-blue-700">
                                                <Check className="mr-1 h-4 w-4" />
                                                Approve
                                            </Button>
                                            <Button size="sm" variant="ghost">
                                                <X className="h-4 w-4" />
                                            </Button>
                                        </>
                                    ) : null}
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    );
}

export default PrescriptionsList;